"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgUserClockFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("defs", null,
            React.createElement("style", null, '.user-clock_filled_svg__cls-1{display:none}')),
        React.createElement("path", { className: "user-clock_filled_svg__cls-1", d: "M0 0h32v32H0z", id: "user-clock_filled_svg__transparent_box" }),
        React.createElement("g", { id: "user-clock_filled_svg__FILLED" },
            React.createElement("path", { className: "user-clock_filled_svg__cls-1", d: "M11.5 11a2.35 2.35 0 001.81-.57A3.38 3.38 0 0014 8c0-2.49-1-3-2.5-3a2.49 2.49 0 00-1.81.56A3.42 3.42 0 009 8c0 2.48 1 3 2.5 3z" }),
            React.createElement("path", { d: "M22 14a8 8 0 108 8 8 8 0 00-8-8zm-1 5h2v2.58l1.71 1.71-1.42 1.41L21 22.41zM11.5 13a4.4 4.4 0 003.22-1.15A5.21 5.21 0 0016 8c0-4.12-2.45-5-4.5-5a4.39 4.39 0 00-3.23 1.15A5.19 5.19 0 007 8c0 4.12 2.44 5 4.5 5zM9.69 5.56A2.49 2.49 0 0111.5 5C13 5 14 5.51 14 8a3.38 3.38 0 01-.69 2.43 2.35 2.35 0 01-1.81.57C10 11 9 10.48 9 8a3.42 3.42 0 01.69-2.44zM2.42 17.54l-.42.3V25h9.43c-.09-.32-.17-.65-.24-1-.06-.32-.11-.65-.14-1H4v-4.09A15.32 15.32 0 0111.5 17h.7a11 11 0 011.24-1.92A17.18 17.18 0 0011.5 15a16.79 16.79 0 00-9.08 2.54z" }))));
}
exports.default = SvgUserClockFilled;
//# sourceMappingURL=UserClockFilled.js.map